var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":"Top Left 提示文字","placement":"left"}},[_c('div',[_vm._v("上左")])])}
var staticRenderFns = []

export { render, staticRenderFns }